// extracted by mini-css-extract-plugin
export default {"title":"TitleFirstLevel_title__P73ei"};